const config = {
	"url" : process.env.NODE_ENV === "development" ? "localhost:3000" : "https://app.desineo.pl/",
	"urlApi" : (process.env.NODE_ENV === "development" ? "https://kurczepieczone.pl.demo:8890/" : "https://kurczepieczone.pl/") + "api/",
	"title" : "Kurcze Pieczone - System Zamówień",
	"version": "1.1"
}

export default config;
